import type { EthersError } from '@veno-app/sdk';

export const getTxErrorMessage = (error: EthersError) => {
  if (error.code === 'ACTION_REJECTED') {
    return 'User declined transaction';
  }
  const errorMessage = error.reason ?? error.message ?? error.toString();
  return `Something went wrong: \n${
    errorMessage.length > 700
      ? errorMessage.substring(0, 700) + '...'
      : errorMessage
  }`;
};
